module.exports = __webpack_public_path__ + "media/src/components/shared/general/rating_img/halfPinkStar-24cc69f59ed793a14eb6dff2418034c3.png";